import { render, staticRenderFns } from "./BuildingBE.vue?vue&type=template&id=92508e0c&scoped=true&"
import script from "./BuildingBE.vue?vue&type=script&lang=js&"
export * from "./BuildingBE.vue?vue&type=script&lang=js&"
import style0 from "./BuildingBE.vue?vue&type=style&index=0&id=92508e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92508e0c",
  null
  
)

export default component.exports